import ReviewCard from "components/common/Card/ReviewCard";
import Carousel from "components/common/Carousel";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import useMediaQuery from "hooks/useMediaQuery";
import React, { useCallback, useMemo } from "react";
import styles from "../index.module.scss";
import "./index.css";

const Comments = ({className}) => {
  const { lifeChoice } = useLifeChoicePageContext();
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);

  const carouselOptions = useMemo(
    () =>
      isDesktop
        ? {
            slidesPerView: 2,
            pagination: { clickable: true },
          }
        : { pagination: { clickable: true } },
    [isDesktop]
  );

  const renderItem = useCallback(
    (item) => (
      <ReviewCard
        cardType="overviewCard"
        item={item}
      />
    ),
    [isDesktop]
  );

  return (
    <div
      className={`${styles["comments"]} ${
        !isDesktop && "container-right-aligned"
      }`}
    >
      <Carousel
        items={lifeChoice.reviews}
        renderItem={renderItem}
        options={carouselOptions}
        className={className}
      />
    </div>
  );
};

export default Comments;
